import { Directive, ElementRef, Input, HostListener, Output, EventEmitter } from '@angular/core';


@Directive({
    selector: '[pattern]'
})
export class PatternDirective {

    constructor(private el: ElementRef) {
    }

    @Input() pattern: string;

    @Input() ngModel;
    @Output() ngModelChange = new EventEmitter();
    regexp: RegExp;
    lastValue = '';


    @HostListener('input', ['$event.target.value'])
    onInput(value) {
        this.regexp = new RegExp(this.pattern, 'g');
        this.lastValue = this.el.nativeElement.value = value.match(this.regexp) ? value : this.lastValue;
        this.ngModelChange.emit(this.lastValue);
    }
}
